import { useEffect, useState } from 'react';

const KEYBOARD_MIN_HEIGHT_PX = 140;

// True while the on-screen keyboard is (very likely) open — the visual
// viewport shrinks by at least ~140px against the layout viewport. Used to
// hide the bottom tab bar so it never floats above the keyboard.
export const useKeyboardOpen = (): boolean => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) {
      return;
    }
    // Compare against the tallest viewport seen (keyboard closed) — NOT
    // window.innerHeight, which iOS also shrinks when the keyboard opens, so the
    // difference would stay ~0 and never trip.
    let base = vv.height;
    const onChange = () => {
      base = Math.max(base, vv.height);
      setOpen(base - vv.height > KEYBOARD_MIN_HEIGHT_PX);
    };
    onChange();
    vv.addEventListener('resize', onChange);
    return () => vv.removeEventListener('resize', onChange);
  }, []);

  return open;
};
